import React, { useEffect, useState, useCallback } from "react"
import { useSelector } from "react-redux"
import { loadStripe } from '@stripe/stripe-js'
import { getStripeClient, stripeCallBack } from '../../../../../../../api'

import {
    Elements,
    ElementsConsumer,
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement,
} from '@stripe/react-stripe-js'

import useCreditPay from '../hooks/credit-pay'
import getPublicKey from "../../../../../../utils/get-public-key"


export default Wrapped => {
    return props => {
        const { creditOrder, payMethod, onError, trackPayOrder } = props
        const [stripe, setStripe] = useState(null)
        const global = useSelector(state => state.global)
        const { config } = global

        const {
            pay,
            paying,
            canPay
        } = useCreditPay({
            onError
        })

        const [cardError, setCardError] = useState(null)
        const [expiryError, setExpiryError] = useState(null)
        const [cvvError, setCvvError] = useState(null)
        const [submiting, setSubmiting] = useState(false)

        const handleCardError = useCallback(state => {
            const { error } = state
            if (error) {
                setCardError(error?.message)
            } else {
                setCardError('')
            }
        }, [])

        const handleExpiryError = useCallback(state => {
            const { error } = state
            if (error) {
                setExpiryError(error?.message)
            } else {
                setExpiryError('')
            }
        }, [])

        const handleCvvError = useCallback(state => {
            const { error } = state
            if (error) {
                setCvvError(error?.message)
            } else {
                setCvvError('')
            }
        }, [])

        useEffect(async () => {
            console.log(getPublicKey(config?.paykeys?.stripe?.publicKey, payMethod))
            setStripe(await loadStripe(getPublicKey(config?.paykeys?.stripe?.publicKey, payMethod)))
        }, [payMethod])

        const handleSumbit = async (e, elements) => {
            e.preventDefault()
            setSubmiting(true)

            const couldPay = await canPay()

            if(!couldPay){
                window.location.href = `/order-confirm/${creditOrder?.order?.transactionId}?transactionId=${creditOrder?.order?.transactionId}`
                return
            }

            if (props.showNew) {
                trackPayOrder()
                const response = await getStripeClient({ orderId: creditOrder?.order?.id, payMethod })
                const billingAddress = creditOrder?.order?.billingAddress || creditOrder?.order?.shippingDetail
                if (response?.code === 200) {
                    const result = response.result
                    const payload = await stripe.confirmCardPayment(result.clientSecret, {
                        payment_method: {
                            type: 'card',
                            card: elements.getElement(CardNumberElement),
                            billing_details: {
                                name: billingAddress?.name,
                                email: billingAddress?.email,
                                phone: billingAddress?.phoneNumber,
                                address: {
                                    city: billingAddress?.city,
                                    country: billingAddress?.country?.value,
                                    line1: billingAddress?.streetAddress1,
                                    line2: billingAddress?.unit,
                                    postal_code: billingAddress?.zipCode,
                                    state: billingAddress?.state?.value
                                },
                            },
                        }
                    })

                    const { paymentIntent, error } = payload

                    if (error?.type === 'validation_error') {
                        if (error.code) {
                            if (error.code.indexOf('_number') > 0) {
                                elements.getElement(CardNumberElement)?.focus?.()
                            }

                            if (error.code.indexOf('_expiry') > 0) {
                                elements.getElement(CardExpiryElement)?.focus?.()
                            }

                            if (error.code.indexOf('_cvc') > 0) {
                                elements.getElement(CardCvcElement)?.focus?.()
                            }
                        }

                        setSubmiting(false)

                        return
                    }


                    const stripeResponse = await stripeCallBack({
                        ...payload,
                        orderId: creditOrder?.order?.id,
                        transactionId: creditOrder?.order?.transactionId,
                        payMethod,
                        pid: result.pid,
                        paymentMethodId: paymentIntent ? paymentIntent.payment_method : undefined
                    })

                    if (stripeResponse.code === 200) {
                        const {
                            success,
                            details,
                            noticeType,
                            transactionId,
                            redirectPayMethod,
                            status,
                            shopUrl,
                            cartToken,
                            checkoutId
                        } = stripeResponse.result || {}


                        if (success) {
                            window.location.href = `/order-confirm/${transactionId}?transactionId=${transactionId}`
                        } else {
                            onError({
                                message: details,
                                payMethod,
                                noticeType,
                                redirectPayMethod,
                                //deco
                                deco: {
                                    decoStatus: status,
                                    shopUrl,
                                    cartToken,
                                    checkoutId
                                }
                            })
                        }
                    } else {
                        onError({
                            message: stripeResponse.result,
                            payMethod: payMethod
                        })
                    }

                    setSubmiting(false)

                } else {
                    onError({
                        message: response?.result || 'Network Error.',
                        payMethod: payMethod
                    })
                }
            }else{
               await pay()
            }
            setSubmiting(false)
        }

        return <Elements stripe={stripe}>
            <ElementsConsumer>
                {({ stripe, elements }) => (
                    <Wrapped {...props} stripe={stripe} elements={elements}
                        cardError={cardError}
                        handleCardError={handleCardError}
                        expiryError={expiryError}
                        handleExpiryError={handleExpiryError}
                        cvvError={cvvError}
                        handleCvvError={handleCvvError}
                        submiting={submiting || paying}
                        handleSumbit={handleSumbit}
                    />
                )}
            </ElementsConsumer>
        </Elements>
    }
}